define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/Controller",
	"csi/comm/Aspera",
	"csi/comm/GetRequest",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/widget/MessageDialog"
], function(declare,lang,csi,Controller,Aspera,GetRequest,PostRequest,locale,MessageDialog) {

	return declare(Controller, {

		hasToConfirmAction: function() {
			return true;
		},

		confirmAction: function(params) {
			// summary: issue request so as to be able to receive return value
			this.setProgress();

			new PostRequest("Sourcing", "SRLineItemHasDocuments")
				.addParameter("ParentURL", this.m_urlNode)
				.post({}).then(lang.hitch(this, this._onHasDocuments));
		},

		_onHasDocuments: function(/*Response*/response) {

			if (response.getReturnValue()) {
				this.preProcess();
			} else {
				this.displayErrorDialog({
					materialIcon: MessageDialog.ICON_WARNING,
					message: locale.resource("NoDocumentToZip_Error"),
					title: locale.resource("WARNING")
				});
			}
		},

		toWriter: function() {
			var request;
			if (Aspera.isEnabled()) {
				let transferSpec = null;
				request = new PostRequest("Sourcing", "DataPackageZipDownload")
					.addParameter("URL", this.m_urlNode)
					.post({handleAs: "json"}).then(
						(response) => {
							transferSpec = response.data;
							return Aspera.downloadFileFromSpec(transferSpec);
						}
					).then(
						function() {
							if (transferSpec) {
								let deleteRequest = new PostRequest("SiteAdmin", "DeleteDataPackageZip");
								deleteRequest.addParameter("FileName", transferSpec.transfer_specs[0].transfer_spec.paths[0].destination);
								return deleteRequest.post();
							} else {
								return null;
							}
						}
					).then(
						(msg) => {
							this.postProcess();
						}
					);
			} else {
				request = new GetRequest("Sourcing", "LineItemZipDownload")
					.addParameter("URL", this.m_urlNode);

				csi.browserWindow(request.toRequest(), "Sourcing");
			}
        }
    });
});